/**
 * @file collegeActivity.js
 * @author Geoffrey Pursell
 * @desc PostGradIndicators report plugin

*/

/**
 * @module collegeActivity 
 * @desc PostGradIndicators report plugin
 */

define('plugins/collegeActivity',["underscore",
        "cardboard/models", "cardboard/collections", "cardboard/util", "models",
        "text!plugins/templates/collegeActivity_topTen_table.html!strip", "text!plugins/templates/collegeActivity_enrollment_table.html!strip", "text!plugins/templates/collegeActivity_enrollmentOptions_table.html!strip", "text!plugins/templates/collegeActivity_firstYearCredits_table.html!strip", "text!plugins/templates/collegeActivity_timeTrends_table.html!strip", "cardboard/pluginPieces"],
       function (_,
                  CardboardModels, CardboardCollections, Util, SLEDSModels,
                  topTenTemplate, enrollmentTemplate, enrollmentOptionsTemplate, firstYearCreditsTemplate, timeTrendsTemplate, PluginPieces) {

    console.log("MODULE: collegeActivity");

    var exports = {

        // options for the demo cats config. since this is a multi-select
        // report, we have to use a different view object, and tell it not to
        // show grades as categories.
        options: {
            dynamicTextDomain: "collegeEnrollment",
            orgDetailPane: false,
            noMapSearch: true,
            forcedSummaryFilters: ["collegeActivityCOHORTID"],
            // Show Filter definitions link at bottom of filter pane
            definitions: true
        },

        // each of these is the configuration that gets passed to a
        // DataBoxPaneView.
        panes: [
            {
                title: "College Enrollment",
                //titlePath: "collegeEnrollment.contents.0",
                explanationText: "This report shows the percent of high school graduates enrolling in college the fall after high school graduation.",
                //explanationTextPath: "collegeEnrollment.contents.1",
                openByDefault: true,
                views: [
                    {
                        type: "template",
                        template: "<h5>Percent of HS Graduates Enrolling in College - Fall</h5>",
                        dataSourceName: "data"
                    },
                    {
                        // SETUP
                        // one glob = one line series
                        // in each series, one row = one data point
                        type: "stackedColumn",
                        dataSourceName: "data",
                        dataPath: "collegeEnrollment.slices",

                        // "pointsWithinRows": given that the data is
                        // two-dimensional (meaning an array of arrays, or
                        // similar structure, implying that we have more than
                        // one series to plot) each series is contained in a
                        // "row", like so:
                        //	 +---------+
                        //	 | X X X X |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 +---------+
                        dataShape: "pointsWithinRows",
                        dataDimensions: 2,

                        // DISPLAY
                        // xAxisLabelPath: "subjects.label",
                        unitString: "%",
                        showLegend: true,
                        // yAxisMin: 1,
                        // yAxisMax: 50000,
                        // yAxisType: "logarithmic",

                        // SERIES
                        series: [
                            {
                                seriesDisplayNamePath: "label",
                                dataPath: "organizations",
                                displayNamePath: "orgName",
                                valuePath: "percent",
                           
                            },
                            {
                                seriesDisplayNamePath: "label",
                                dataPath: "organizations",
                                displayNamePath: "orgName",
                                valuePath: "percent",
                               
                            }
                        ],
                        //errorConditions: [PluginPieces.standardErrorCondition]
                    },
                    {
                        type: "template",
                        template: enrollmentTemplate,
                        dataSourceName: "data",
                        //errorConditions: [PluginPieces.silentStandardErrorCondition]
                    }
                ]
            },
            {
                title: "Where HS Graduates go to College - Fall",
                explanationText: "This report shows the type of college attended by high school graduates in the fall.",
                openByDefault: false,
                views: [
                    {
                        type: "template",
                        template: "<h5>Of Students Enrolling in College the Fall after HS Graduation</h5>"
                    },
                    {
                        // SETUP
                        // one glob = one line series
                        // in each series, one row = one data point
                        type: "stackedColumn",
                        dataSourceName: "data",
                        dataPath: "enrollmentOptions.slices",

                        // "pointsWithinRows": given that the data is
                        // two-dimensional (meaning an array of arrays, or
                        // similar structure, implying that we have more than
                        // one series to plot) each series is contained in a
                        // "row", like so:
                        //	 +---------+
                        //	 | X X X X |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 +---------+
                        dataShape: "pointsWithinRows",
                        dataDimensions: 2,

                        // DISPLAY
                        unitString: "%",
                        showLegend: true,

                        // SERIES
                        series: [
                            {
                                seriesDisplayNamePath: "label",
                                dataPath: "organizations",
                                displayNamePath: "orgName",
                                valuePath: "percent",
                                
                            },
                            {
                                seriesDisplayNamePath: "label",
                                dataPath: "organizations",
                                displayNamePath: "orgName",
                                valuePath: "percent",
                              
                            },
                            {
                                seriesDisplayNamePath: "label",
                                dataPath: "organizations",
                                displayNamePath: "orgName",
                                valuePath: "percent",
                               
                            },
                            {
                                seriesDisplayNamePath: "label",
                                dataPath: "organizations",
                                displayNamePath: "orgName",
                                valuePath: "percent",
                              
                            },
                            {
                                seriesDisplayNamePath: "label",
                                dataPath: "organizations",
                                displayNamePath: "orgName",
                                valuePath: "percent",
                               
                            }
                        ],
                        //errorConditions: [PluginPieces.standardErrorCondition]
                    },
                    {
                        type: "template",
                        template: enrollmentOptionsTemplate,
                        dataSourceName: "data",
                        //errorConditions: [PluginPieces.silentStandardErrorCondition]
                    }
                ]
            },

            {
                title: "Credits Taken in First Term of College - Fall",
                explanationText: "This report shows the number of credits taken by high school graduates during their first term of college. Note that credit-level data is not available for students attending colleges outside Minnesota or non credit-based programs.",
                openByDefault: false,
                views: [
                    {
                        type: "template",
                        template: "<h5>Of Students Enrolling in College the Fall after HS Graduation</h5>"
                    },
                    {
                        // SETUP
                        // one glob = one line series
                        // in each series, one row = one data point
                        type: "stackedColumn",
                        dataSourceName: "data",
                        dataPath: "firstYearCredits.slices",

                        // "pointsWithinRows": given that the data is
                        // two-dimensional (meaning an array of arrays, or
                        // similar structure, implying that we have more than
                        // one series to plot) each series is contained in a
                        // "row", like so:
                        //	 +---------+
                        //	 | X X X X |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 +---------+
                        dataShape: "pointsWithinRows",
                        dataDimensions: 2,

                        // DISPLAY
                        unitString: "%",
                        showLegend: true,
                        legendReversed: true,

                        // SERIES
                        series: [
                            {
                                seriesDisplayNamePath: "label",
                                dataPath: "organizations",
                                displayNamePath: "orgName",
                                valuePath: "percent",
                       
                            },
                            {
                                seriesDisplayNamePath: "label",
                                dataPath: "organizations",
                                displayNamePath: "orgName",
                                valuePath: "percent",
                             
                            },
                            {
                                seriesDisplayNamePath: "label",
                                dataPath: "organizations",
                                displayNamePath: "orgName",
                                valuePath: "percent",
                               
                            },
                            {
                                seriesDisplayNamePath: "label",
                                dataPath: "organizations",
                                displayNamePath: "orgName",
                                valuePath: "percent",
                              
                            },
                            {
                                seriesDisplayNamePath: "label",
                                dataPath: "organizations",
                                displayNamePath: "orgName",
                                valuePath: "percent",
                            
                            }
                        ],
                        //errorConditions: [PluginPieces.standardErrorCondition]
                    },
                    {
                        type: "template",
                        template: firstYearCreditsTemplate,
                        dataSourceName: "data",
                        //errorConditions: [PluginPieces.silentStandardErrorCondition]
                    }
                ]
            },
            {
                title: "Top 25 Colleges Attended - Fall",
                explanationText: "This report shows the top 25 colleges attended by high school graduates in the fall.",
                openByDefault: false,
                views: [
                    {
                        type: "template",
                        template: "<h5>Of Students Enrolling in College the Fall after HS Graduation</h5>"
                    },
                    {
                        type: "template",
                        template: topTenTemplate,
                        dataSourceName: "data",
                        //errorConditions: [PluginPieces.standardErrorCondition]
                    }
                ]
            },
            {
                title: "Time Trends",
                //titlePath: "collegeEnrollment.contents.0",
                explanationText: "This report shows the percent of high school graduates enrolling in college by time of enrollment and year of high school graduation.",
                //explanationTextPath: "collegeEnrollment.contents.1",
                openByDefault: false,
                views: [
                    {
                        type: "template",
                        template: "<h5>Minnesota Public High School Graduates' College Enrollment</h5>",
                        dataSourceName: "data"
                    }, 
                    {
                        // SETUP
                        // one glob = one line series
                        // in each series, one row = one data point
                        type: "stackedColumn",
                        dataSourceName: "data",
                        dataPath: "timeTrendsReport.slices",

                        // "pointsWithinRows": given that the data is
                        // two-dimensional (meaning an array of arrays, or
                        // similar structure, implying that we have more than
                        // one series to plot) each series is contained in a
                        // "row", like so:
                        //	 +---------+
                        //	 | X X X X |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 +---------+
                        dataShape: "pointsWithinRows",
                        dataDimensions: 2,

                        // DISPLAY
                       //  xAxisLabel: "Graduating Class",
                        unitString: "%",
                        showLegend: true,
                       // yAxisLabel: "Percent Enrolled in College",

                        // SERIES
                        series: [
                            {
                                seriesDisplayNamePath: "label",
                                dataPath: "years",
                                displayNamePath: "year",
                                valuePath: "percent",
                           
                            }
                        ],
                      //  errorConditions: [PluginPieces.standardErrorCondition]
                      errorConditions: [
                        {
                           valuePath: "data",
                            is: null,
                            error: {
                                type: "NoData",
                                message: "We have no time trends data at this time for the selected criteria."
                            }
                        }
                    ]
                    },
                     {
                        type: "template",
                        template: timeTrendsTemplate,
                        dataSourceName: "data",
                        //errorConditions: [PluginPieces.silentStandardErrorCondition]
                        errorConditions: [
                            {
                               valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }
                        ]
                    } 
                ]
            },  
            {
                title: "More Information",
                visibleByDefault: true,
                openByDefault: false,
                views: [
                    {
                        type: "template",
                        template: "<p><a href='' data-role='button' class='ui-link ui-btn ui-shadow ui-corner-all' role='button'>Download All Data</a></p><p>In these reports, Minnesota public high school graduate data includes student records with a Status End code \"8\" or \"9\". These data are not the same student cohorts used by MDE to calculate the high school graduation rate.</p> <p>For more information on MCA and ACT results of Minnesota public high school graduates, please visit the  <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=059077&RevisionSelectionMethod=latestReleased&Rendition=primary'>Data Interpretation Guide</a> and the <a href='http://www.ohe.state.mn.us/sPages/GettingPrepared.cfm'  target='_blank'>Getting Prepared Report</a>.</p><p>These reports display graduates according to their last reported year of high school graduation.</p><p><a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde031875&RevisionSelectionMethod=latestReleased&Rendition=primary'>Download web report data</a> for all high schools and years. Please note this file does not include subgroup statistics. For more information, <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde031756&RevisionSelectionMethod=latestReleased&Rendition=primary'>read the help document</a>.</p>"
                    }
                ]
            }

        ],

        filterSources: {

            orgs: {
                //	 RCModels.RCOrgList,
                modelType: SLEDSModels.SLEDSOrgList,
                url: "/ibi_apps/WFServlet?IBIF_ex=sledsws_getdata_filter_hsgrad_orgid.fex",
                noViewParams: true,
                enabled: true
            },
            filters: {
                modelType: CardboardModels.FilterData,
                url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_ecodevregion.fex",
                enabled: true
            },
            filters2: {
                url: "/ibi_apps/WFServlet?IBIF_ex=sledsws_getdata_filter_collegeactivitycohortid.fex",
                enabled: true,
                modelType: CardboardModels.FilterData
            },
            filters3: {
                modelType: CardboardModels.FilterProducer,
                filterSources: ["filterForReport"],
                urls: {
                    filterForReport: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_collegeactivity_dropdowns.fex"
                },
                enabled: true,
            },
            demographicCategories: {
                modelType: CardboardCollections.DemoCatProducer,
                url: "/ibi_apps/WFServlet?IBIF_ex=sledsws_getdata_filter_demographics.fex",
                enabled: true,
                noViewParams: false,
                isCat: true
            }
        },
        dataSources: {
            data: {
                modelType: CardboardModels.DocumentModel,
               //  url: "/data/tt.json",
                // url: "/data/mocks/preGradData_statewide.json",
                url: "/ibi_apps/WFServlet?IBIF_ex=sledsws_getdata_collegeActivity.fex",
                // yearPath: "dataYear",
                defaultParams: {
                    orgId: 999999000
                  //  COHORTID: 2018
                },
                paramMappings: {
                    HSGRAD_ORGID: "orgId",
                    orgName: null // skip this
                },
                postProcessor: function (data) {
                    // all we need to do is prettify all the org names!

                    var blobs = [
                        data.collegeEnrollment.slices,
                        data.enrollmentOptions.slices,
                        data.firstYearCredits.slices,
                        data.timeTrendsReport.slices,
                        data.developmentalCredits.slices,
                        data.topTenInstitutions.institutions
                    ];

                    _(blobs).each(function (slices) {
                        _(slices).each(function (slice) {
                            _(slice.organizations).each(function (org) {
                                org.orgName = Util.Data.prettifyName(org.orgName);
                            });
                        });
                    });
                },
                enabled: true,
                errorConditions: [
                    {
                        valuePath: "errorMessage",
                        isNot: null,
                        error: {
                            type: "NoData",
                            message: "Sorry, we don't have any data for your selected school/district and year."
                        }
                    }
                ]
            }
            // http://edu-wfdevtest/ibi_apps/WFServlet?IBIF_ex=sledsws_getdata_contact_information.fex&HSGRAD_ORGID=999999000
        }
    };

    return exports;
});
